import { useSession } from 'next-auth/react';
import type { FeatureFlag } from './flags';

export const useFeature = (flag: FeatureFlag): boolean => {
  const { data: session } = useSession();
  return session?.features?.includes(flag) ?? false;
};
